import axios from "axios";

export const Axios = axios.create({
  timeout: 20_000,
  headers: { "content-type": "application/json" }
});
